
import React from "react";
import { Classname } from "@rivtn/noseur";
import { IReview } from "../../data";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";

export interface TestimonialsProps {
    reviews: IReview[];
}

function Testimonials({ reviews }: TestimonialsProps) {

    const labels = i18nManager.Labels.home;
    const [active, setActive] = React.useState(0);
    const review = reviews[active];
    const average = reviews.reduce((acc, r) => acc + r.rating, 0) / Math.max(reviews.length, 1);
    const fiveStar = Math.round((reviews.filter((r) => r.rating === 5).length / Math.max(reviews.length, 1)) * 100);
    const stats: [string, string][] = [
        [average.toFixed(1), labels.rating],
        [`${reviews.length}`, labels.reviews],
        [`${fiveStar}%`, labels.five_star],
    ];
    const go = (direction: 1 | -1) => setActive((a) => (a + direction + reviews.length) % reviews.length);

    if (!review) return null;

    return (<section className={styles["testimonials"]}>
        <div className={styles["container"]}>
            <div className={styles["testi-head"]}>
                <span className={styles["tag"]}>{labels.testimonial}</span>
                <h2 className={styles["h-02"]}>{labels.testimonial_title}</h2>
            </div>
            <div className={styles["testi-card"]}>
                <div className={styles["testi-img"]}>
                    <img key={review.id} src={review.avatar} alt={review.author} />
                </div>
                <div className={styles["testi-content"]}>
                    <div className={styles["testi-stars"]} aria-label={`${review.rating}/5`}>
                        {Array.from({ length: 5 }, (_, i) => (<i key={i} className={i < review.rating ? "fa fa-star" : "fa-regular fa-star"} />))}
                    </div>
                    <p key={review.id} className={Classname.build(styles["h-05"], styles["fade-in"])}>“{review.text}”</p>
                    <div className={styles["testi-profile"]}>
                        <span className={styles["testi-name"]}>{review.author}</span>
                        <span className={styles["testi-role"]}>{review.tournament}</span>
                    </div>
                    <div className={styles["testi-divider"]} />
                    <div className={styles["testi-stats"]}>
                        {stats.map(([v, l]) => (<div key={l} className={styles["testi-stat"]}>
                            <span className={styles["h-04"]}>{v}</span>
                            <span className={styles["testi-role"]}>{l}</span>
                        </div>))}
                    </div>
                </div>
            </div>
            {reviews.length > 1 && (<div className={styles["arrows"]}>
                <button className={Classname.build(styles["arrow"], styles["arrow-light"])} onClick={() => go(-1)} aria-label="Previous"><i className="fa fa-arrow-left" /></button>
                <button className={Classname.build(styles["arrow"], styles["arrow-light"])} onClick={() => go(1)} aria-label="Next"><i className="fa fa-arrow-right" /></button>
            </div>)}
        </div>
    </section>);
}

export default Testimonials;
